module.exports = __webpack_public_path__ + "img/experiencing-pain-cover.636ee76a.jpg";